import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { registerPhoneAudioReference } from 'flow/actions/phone-actions';
import { ToneGenerator } from 'resources/tone-generator';
import { getPreferredAudioOutputVolume } from 'flow/utils/browser-utils';
import { fetchConnectedMediaDevices } from 'flow/actions/headset-actions';
import { setActiveMeetingAudioReferenceAction } from 'flow/actions/meeting-actions';
import { isLocalFocusedCallSessionEstablished } from 'flow/selectors/call-selectors';

class AudioReference extends React.PureComponent {
    static propTypes = {
        handleRegisterPhoneAudioReference: PropTypes.func.isRequired,
        attachMediaDevices: PropTypes.func.isRequired,
        setActiveMeetingAudioReferenceAction: PropTypes.func.isRequired,
        currentSessionActive: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.audioRef = React.createRef();
        this.conferenceAudioRef = React.createRef();
        this.toneGeneratorRef = React.createRef();
        this.toneGeneratorAdditionalRingtoneRef = React.createRef();
    }

    componentDidMount() {
        this.props.handleRegisterPhoneAudioReference(this.audioRef.current);
        this.props.setActiveMeetingAudioReferenceAction(
            this.conferenceAudioRef.current,
        );
        this.audioRef.current.volume = getPreferredAudioOutputVolume();

        this.props.attachMediaDevices();
        ToneGenerator.setOutputElement(this.toneGeneratorRef.current);
    }

    render() {
        return (
            <div>
                <audio ref={this.audioRef} autoPlay={true} />
                <audio
                    ref={this.conferenceAudioRef}
                    autoPlay={true}
                    muted={!!this.props.currentSessionActive}
                />
                <audio ref={this.toneGeneratorRef} autoPlay={true} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const currentSessionActive = isLocalFocusedCallSessionEstablished(state);
    return { currentSessionActive };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleRegisterPhoneAudioReference: (ref) => {
            dispatch(registerPhoneAudioReference(ref));
        },
        attachMediaDevices: () => {
            dispatch(fetchConnectedMediaDevices);
        },
        setActiveMeetingAudioReferenceAction: (audioReference) =>
            dispatch(setActiveMeetingAudioReferenceAction(audioReference)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AudioReference);
